import EstimateAllocateUtils from "./estimate-allocate-utils";
import formatDate from "../format/date";

const Format = {

    // USER DATE TIME FORMAT
    dateUserFormat(moment) {
        console.warn('Depricated - use formatDate import from core/gd/format/date')
        return formatDate(moment)

        // OLD
        // let format = gd.session.me.formatSettings.date;
        //
        // // this is experimental patch available only here... if old year show old year
        // if (format === 'MMM D' && moment.year()!==Moment().year()) format = "MMM D, YYYY"
        //
        // return moment.format(format);
    },

    datetimeUserFormat(moment) {
        return moment.format(gd.session.me.formatSettings.datetime);
    },

    timeUserFormat(moment) {
        return moment.format(gd.session.me.formatSettings.time);
    },

    //


    number(value, decimalPlaces = 2, addCommas = false) {

        let normalized = typeof value === 'number' ? value.toFixed(decimalPlaces) : parseFloat(value).toFixed(decimalPlaces);
        normalized = isNaN(normalized) ? 0 : normalized;

        if (addCommas) {
            let parts = normalized.toString().split(".");
            return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (parts[1] ? "." + parts[1] : "");
        }

        return normalized;
    },

    currency(value, decimalPlaces = 2, addCommas = false) {
        return Format.number(value, decimalPlaces, addCommas)
    },

    date(moment, format, humanLabels=false) {

        let result = moment.format(format);

        if (humanLabels) {
            const today = Moment();

            if (moment.diff(today,'days')===0) result = 'Today';
            if (moment.diff(today,'days')===1) result = 'Tomorrow';
            if (moment.diff(today,'days')===-1) result = 'Yesterday';

        }

        return result;
    },

    specialCharactersToHtml(str) {
        return str.replace(/&amp;/g, "&").replace(/&gt;/g, ">").replace(/&lt;/g, "<").replace(/&quot;/g, "\"");
    },

    time(moment, format=null) {

        if (!format) {
            format = gd.session.me.formatSettings.time;
        }

        if (!moment) {
            console.warn("fromat-123 no moment passed");
            return '';
        }

        return moment.format(format);

    },

    workWeekInObjectFormat(workweekArray) {
        return {
            'mon': !!workweekArray[0],
            'tue': !!workweekArray[1],
            'wed': !!workweekArray[2],
            'thu': !!workweekArray[3],
            'fri': !!workweekArray[4],
            'sat': !!workweekArray[5],
            'sun': !!workweekArray[6]
        };
    },

    minutesToHoursDecimal(minutes) {

        return EstimateAllocateUtils.minutesToHours(minutes,2)

    }


};

export default Format;
